var render = function render(){var _vm=this,_c=_vm._self._c;return (!!_vm.data)?_c('span',[(!_vm.tip)?[_vm._v(" 对比同版位同类型产品出价均值 "),_c('span',{staticClass:"red"},[_vm._v(_vm._s(_vm.data))])]:[(_vm.data ==='0')?[_vm._v(" 与同版位同类型产品出价均值 "),_c('span',{staticClass:"red"},[_vm._v("一致")])]:_vm._e()]],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }